// Listing detail page — scroll-spy highlight for the sticky sub-nav.
// Mirrors the IntersectionObserver pattern from the mockup.
export {};

const init = () => {
  const links = Array.from(document.querySelectorAll<HTMLAnchorElement>("[data-subnav]"));
  if (links.length === 0) {
    return;
  }

  const linkById = new Map<string, HTMLAnchorElement>();
  links.forEach((a) => {
    const id = a.dataset.subnav;
    if (id) {
      linkById.set(id, a);
    }
  });

  const setActive = (id: string) => {
    links.forEach((l) => l.removeAttribute("data-active"));
    linkById.get(id)?.setAttribute("data-active", "true");
  };

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) {
          setActive(e.target.id);
        }
      });
    },
    {rootMargin: "-120px 0px -65% 0px", threshold: 0},
  );

  linkById.forEach((_, id) => {
    const el = document.getElementById(id);
    if (el) {
      observer.observe(el);
    }
  });
};

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", init);
} else {
  init();
}
